import React from 'react';
import dayjs from 'dayjs';
import {Typography} from '@mui/material';
import {DataId, Sx} from 'app/types/common';

interface Props extends Sx, DataId {
  timestamp: number;
}

export default function InvoiceDate({sx, dataId, timestamp}: Props) {
  return (
    <Typography sx={sx} data-id={dataId}>
      {dayjs.unix(timestamp).format('ll')}
    </Typography>
  );
}
